<template>
  <v-dialog max-width="500px" v-bind="$attrs" v-model="show">
    <file-picker
      :accept="accept || '.png,.jpg,.jpeg,.pdf,.csv,.xlsx,.xls'"
      :title="title"
      multiple
      slot="activator"
      v-bind="$attrs"
      v-model="files"
    ></file-picker>
    <v-card>
      <v-card-title>アップロード</v-card-title>
      <v-list two-line>
        <v-list-tile :key="index" v-for="(f, index) in files">
          <v-list-tile-content>
            <v-list-tile-title>{{ f.name }}</v-list-tile-title>
            <v-list-tile-sub-title
              >{{ f.loaded }}/{{ f.size }} {{ f.result }}</v-list-tile-sub-title
            >
            <v-list-tile-sub-title>
              <v-progress-linear
                class="mt-0"
                v-model="f.progress"
              ></v-progress-linear>
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="show = false" flat v-if="!uploading">クローズ</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { Promise } from 'q'
export default {
  props: [
    'title',
    'domain',
    'businessKey',
    'category',
    'accept',
    'allowDuplicateName',
  ],
  data() {
    return {
      show: false,
      uploading: false,
      files: [],
    }
  },
  watch: {
    files() {
      if (this.files.length <= 0) return
      this.show = true
      this.uploading = true

      Promise.all(this.getRemoveTasks())
        .then((results) => {
          console.log({ results })
          return Promise.all(this.getUploadTasks())
        })
        .then((results) => {
          console.log({ results })
          this.uploading = false
        })
    },
  },
  methods: {
    getKey() {
      return this.businessKey
        .replace(new RegExp('/', 'g'), '_&_')
        .replace(/ /g, '_&_')
        .replace(/#/g, '_&_')
        .replace(/%/g, '_&_')
        .replace(/,/g, '_&_')
        .replace(/:/g, '_&_')
        .replace(/;/g, '_&_')
        .replace(/</g, '_&_')
        .replace(/=/g, '_&_')
        .replace(/>/g, '_&_')
        .replace(/@/g, '_&_')
    },
    getRemoveTasks() {
      if (this.allowDuplicateName) return ['skip Remove Duplicate Task']
      return this.$http
        .get(`/files/${this.domain}/${this.getKey()}/files`)
        .then((res) => {
          let oldFiles = res.data
          let removeTasks = this.files.map((f) => {
            let old = oldFiles.find(
              (o) => f.name === o.name && o.category === this.category
            )
            if (old) {
              return this.$http
                .delete(
                  `/files/${this.domain}/${this.getKey()}/files/${old.id}`
                )
                .then(() => `remove file ${old.name} id:${old.id}`)
            } else {
              return `${f.name} not duplicate`
            }
          })
          return removeTasks
        })
    },
    getUploadTasks() {
      return this.files.map((f) => {
        let formData = new FormData()
        formData.append('file', f.file)
        formData.append('category', this.category)
        return this.$http
          .post(`/files/${this.domain}/${this.getKey()}/files`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              sortable: false,
            },
            onUploadProgress(event) {
              f.result = 'アップロード中...'
              if (event.lengthComputable) {
                f.progress = (event.loaded * 100) / event.total
                f.loaded = event.loaded
              }
            },
            quiet: true,
          })
          .then(() => {
            f.result = 'アップロードが完了です.'
            return `completed upload ${f.name}`
          })
          .catch((err) => {
            f.result = err.message
            return `failed upload ${f.name}, result:${f.result}`
          })
      })
    },
  },
}
</script>
